module.exports = __webpack_public_path__ + "static/media/bravo.e104fb74.gif";